module.exports = __webpack_public_path__ + "img/lg_ring_g_c_null_0@2x.4cb98adc.png";